import { Component, HostListener } from '@angular/core';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-order-page',
  templateUrl: './user-profile-order-page.component.html',
  styleUrls: ['./user-profile-order-page.component.scss'],
})
export class UserProfileOrderPageComponent {
  status = '';
  loading = false;
  query = '';
  page = 0;
  pageSize = 10;
  orders: any[] = [];

  constructor(
    private api: OrderApiService,
    private message: MessageService,
  ) {}

  ngOnInit(): void {
    this.findUserOrders();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.innerHeight + window.scrollY;
    const max = document.scrollingElement?.scrollHeight || 0;

    if (offset > max - 500 && !this.loading) {
      this.findUserOrders();
    }
  }

  findUserOrders = async () => {
    try {
      this.page++;
      this.loading = true;
      const r = await this.api.findUserOrders(
        this.query,
        this.status,
        this.page,
        this.pageSize,
      );
      const l = r.data || [];
      this.orders = this.orders.concat(l);
      return l.length >= this.pageSize;
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
    return false;
  };

  changeStatus(status: string) {
    this.status = status;
    this.orders = [];
    this.page = 0;
    this.findUserOrders();
  }
}
